import { useT } from '@/core/I18nProvider';

import { showsTranslationNotice } from './translation-notice-visibility';

import type { ReactElement } from 'react';

/**
 * Convenience-translation notice for the binding legal/trust documents.
 *
 * The legal pages (Terms, Privacy, DPA, AI disclosure, Cookies, Security, …) are
 * localized so a non-English visitor reads them in their language — but the
 * **English version is the legally authoritative one**. This banner states that
 * plainly. It renders ONLY when the active locale is non-English (on the English
 * page there is nothing to disclaim), so it never shows redundant text to EN
 * readers. Place it directly under each legal page's heading.
 */
export function LegalTranslationNotice(): ReactElement | null {
  const { locale, t } = useT();
  if (!showsTranslationNotice(locale)) return null;
  return (
    <p
      role="note"
      className="mb-6 rounded-md border border-[color:var(--bd-line)] bg-[color:var(--bd-sunk)] px-4 py-3 text-sm text-[color:var(--bd-muted)]"
    >
      {t('legal.translationNotice')}
    </p>
  );
}
